import React from "react";

const HelpHeader = () => (
  <section className="w-full bg-light-4 py-12 px-6">
    <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-8">
      {/* Illustration */}
      <div className="flex-1 flex justify-center">
        <img
          src="https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
          alt="Jeune aidé par un tuteur"
          className="rounded-2xl shadow-lg w-full max-w-sm md:max-w-md"
        />
      </div>

      {/* Texte */}
      <div className="flex-1 text-center md:text-left">
        <h2 className="text-title font-bold text-dark-1 mb-4">
          Besoin d’un coup de main ? On est là pour toi.
        </h2>
        <p className="text-normal text-light-1 leading-relaxed">
          Le <span className="text-blue-1 font-semibold">Centre d’aide GoNextMaker</span> est ton espace
          pour trouver des réponses rapides, des guides pratiques et du support personnalisé.
        </p>
        <p className="text-normal text-dark-3 mt-3">
          Que tu sois <strong>apprenant, parent, tuteur ou partenaire</strong>, tu trouveras ici toutes les infos essentielles.
        </p>
      </div>
    </div>
  </section>
);

export default HelpHeader;
